export const convertTimeDataToBackend = (time) => time.toString().substring(4).split(' (')[0]
